module.exports = __webpack_public_path__ + "static/media/flag_chile.e043e202.png";